import Copyright from './Copyright';

export default Copyright;
export type { CopyrightProps } from './Copyright';
